export const ERROR_RESPONSES = {
  500: '서버에 문제가 발생했어요',
  networkError: '네트워크에 문제가 발생했어요',
  accessExpired: '액세스 토큰이 만료되었습니다',
};

export const ADMIN = 'administrators';
